import { atom } from 'jotai'
import type { createStore } from 'jotai'
import { atomWithQuery } from 'jotai-tanstack-query'
import { hc, type InferResponseType } from 'hono/client'
import type { VersionHistoryApi } from '@backend/api/stores/VersionHistoryStore'
import { apiFetch, FormError } from '@paraflow-ai/frontend-libs'

type Store = ReturnType<typeof createStore>
const api = hc<VersionHistoryApi>('/api/stores/versionHistory', { fetch: apiFetch })

export const componentIdAtom = atom('')
export const selectedVersionsAtom = atom<string[]>([])
export const showPublishModalAtom = atom(false)
export const showCompareAtom = atom(false)

export const refreshAtom = atomWithQuery((get) => {
  const componentId = get(componentIdAtom)
  return {
    queryKey: ['VersionHistoryStore', componentId],
    queryFn: async () => {
      const res = await api.refresh.$get({ query: { componentId } })
      return await res.json()
    },
    enabled: !!componentId,
  }
})

export const toggleVersionAtom = atom(null, (get, set, versionId: string) => {
  const selected = get(selectedVersionsAtom)
  if (selected.includes(versionId)) {
    set(selectedVersionsAtom, selected.filter(v => v !== versionId))
  } else if (selected.length < 2) {
    set(selectedVersionsAtom, [...selected, versionId])
  }
})

export const publishAtom = atom(null, async (get, set, data: { version: string; changelogNotes?: string }) => {
  const componentId = get(componentIdAtom)
  if (!data.version.trim()) throw new FormError('请输入版本号')

  await api.publish.$post({
    json: {
      componentId,
      version: data.version.trim(),
      changelogNotes: data.changelogNotes || undefined,
    },
  })
  set(showPublishModalAtom, false)
  await get(refreshAtom).refetch()
})

export function loader(store: Store, params: { id?: string }) {
  const id = params.id!
  store.set(componentIdAtom, id)
  store.set(selectedVersionsAtom, [])
  store.set(showPublishModalAtom, false)
  store.set(showCompareAtom, false)
  store.get(refreshAtom)
  return null
}
